export default "__VITE_ASSET__BIDywr3h__"